export default "__VITE_ASSET__BijTUdED__"